'use client';

import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { EpStepContent } from '../components';
import { EpErrorMessage } from '../components/EpErrorMessage';
import { EpFormDatepicker } from '../components/EpFormDatepicker';

export default function NotificationIntubationDateInput({
  translations,
}: {
  translations: unknown;
}) {
  const { getValues, setValue, register } = useFormContext();
  const { language } = useTranslation().i18n;

  const notificationIntubationDate = getValues('notificationIntubationDateId');

  const NotificationIntubationDateId = useWatch({
    name: 'notificationIntubationDateId',
  });
  const PatientBirthDate = useWatch({ name: 'patientBirthDate' });

  if (
    notificationIntubationDate instanceof Date &&
    !isNaN(notificationIntubationDate.valueOf())
  ) {
    setValue(
      'notificationIntubationDateId',
      new Date(NotificationIntubationDateId)?.toLocaleDateString('sv-SE'),
    );
  }

  register('notificationIntubationDateIdIsValid', {
    required: t(
      translations,
      'Date of Incident cannot be earlier than Birth Date.',
    ),
  });

  useEffect(() => {
    if (NotificationIntubationDateId) {
      const incidentDate = new Date(`${NotificationIntubationDateId} 00:00`);
      const birthDate = new Date(PatientBirthDate);
      if (incidentDate < birthDate) {
        setValue('notificationIntubationDateIdIsValid', undefined);
      } else {
        setValue('notificationIntubationDateIdIsValid', true);
      }
    } else {
      setValue('notificationIntubationDateIdIsValid', true);
    }
  }, [NotificationIntubationDateId, PatientBirthDate, setValue]);

  return (
    <EpStepContent.Label
      label={t(translations, 'Date of the incident') + ' *'}
      required={false}
    >
      <EpFormDatepicker
        datepickerId={'form__datepicker--notification-intubation-date'}
        datepickerName={'notificationIntubationDateId'}
        isInlineDatepicker={true}
        cultureCode={language}
        datepickerRequired
        errorMessage={t(translations, '* Required Fied')}
        isoFormatDate
      />
      <EpErrorMessage inputName="notificationIntubationDateId" />
      <EpErrorMessage inputName="notificationIntubationDateIdIsValid" />
    </EpStepContent.Label>
  );
}
